import React, { useState } from "react";
import ConversationDetail from "./ConversationDetail";
import OrderDetail from "./OrderDetail";
import ChatsList from "./ChatList";
import { messagesData } from "./ChatData";

function BulkChat() {
  const [selectedChat, setSelectedChat] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("All");

  const filteredMessages =
  activeTab === "Unread"
    ? messagesData.filter((msg) => msg.isUnread)
    : messagesData;


    const onChatClick = (msg) => {
        setSelectedChat(msg);
        setIsProfileOpen(false);
        setIsChatOpen(false);
      };
    const handleProfileClick = (msg) => {
        setIsProfileOpen(true)
      };

  return (
    <div className="flex h-[90%] w-full">
      <div className="flex-col">
              {/* Tabs */}
      <div className="flex justify-start border-b">
        <button
          className={`w-1/2 p-3 ${
            activeTab === "All" ? "border-b-4 border-blue500" : ""
          }`}
          onClick={() => setActiveTab("All")}
        >
          All
        </button>
        <button
          className={`w-1/2 p-3 ${
            activeTab === "Unread" ? "border-b-4 border-blue500" : ""
          }`}
          onClick={() => setActiveTab("Unread")}
        >
          Unread
        </button>
      </div>

      {/* Search Bar */}
      <div className="flex items-center p-4">
        <input
          type="text"
          placeholder="Search"
          className="w-full p-2 rounded-lg border focus:outline-none"
        />
      </div>
      <div>
        {filteredMessages.map((msg) => (
          <div
            key={msg.id}
            onClick={() => onChatClick(msg)}
            className="flex px-4 justify-between cursor-pointer  hover:bg-lightGrayColor"
          >
      {/* Left - Chats List */}
      
        <ChatsList className=""  msg={msg}/>
      
      </div>
        ))}
      </div>
      </div>
      {/* Center - Conversation or Placeholder */}
      <div className="w-2/4 p-2 h-[100%]">
        {selectedChat && !isChatOpen && (
          <ConversationDetail chat={selectedChat} handleProfileClick={handleProfileClick}/>
        )}
        {!selectedChat && !isChatOpen && (
          <p className="text-[#6B7280] flex justify-center items-center mt-20">Select a message to view the conversation</p>
        )}
      </div>

      {/* Right - Profile or Placeholder */}
      <div className="w-1/4 border-l flex flex-col h-[100%]">
      {selectedChat && (
         <OrderDetail isProfileOpen={isProfileOpen} msg={selectedChat} setIsProfileOpen={setIsProfileOpen} />
      )
    }
      </div>
    </div>
  );
}
export default BulkChat;
